import React, { memo, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom"; // Add this import

import { Button, LogoutCustom } from "../Components";
import Icon from "../../assets/icons/Icon";
import { logoutUser } from "../../store/user/user-action";
import { uiActions } from "../../store/ui/ui-slice";
import { CommonModal, GlobalSearchModal } from "../Components/Modal";
import { Link } from "react-router-dom";
import logo from "/assets/images/logo.png";

const Topbar = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate(); // Add this
  const { user } = useSelector((state) => state.user);
  const { theme } = useSelector((state) => state.ui);
  const [isShow, setIsShow] = useState({
    isOpen: false,
    rowData: null,
    name: "",
    modalTitle: "",
    modalContent: null,
    apiFlag: false,
  });

  // Add these missing variables
  const userDetails = user || {};
  const userName = userDetails?.Name || userDetails?.Username || "User";
  const userImg = userDetails?.ProfileImage || "/assets/images/userIcon.svg";

  useEffect(() => {
    if (theme) {
      const root = document.documentElement;
      root.setAttribute("data-bs-theme", theme);
    }
  }, [theme]);

  const handleTheme = () => {
    const root = document.documentElement;
    const currentTheme = root.getAttribute("data-bs-theme");

    if (currentTheme === "dark") {
      dispatch(uiActions.setTheme("light"));
    } else {
      dispatch(uiActions.setTheme("dark"));
    }
  };

  const handleSideCollapsed = () => {
    const body = document.querySelector("body");
    const currentSize = body.getAttribute("data-sidebar-size");
    if (currentSize && currentSize !== "default") {
      body.setAttribute("data-sidebar-size", "default");
    } else {
      body.setAttribute("data-sidebar-size", "collapsed");
    }
  };

  const handleLogout = async () => {
    await logoutUser(dispatch);
  };

  // Add missing function
  const handleMenuClick = (path) => {
    navigate(path);
  };

  // Add missing function
  const handleConfirmLogout = () => {
    // You can add a confirmation modal here if needed
    if (window.confirm("Are you sure you want to logout?")) {
      handleLogout();
    }
  };

  // Add missing utility function
  const getRemainingDays = (endDate) => {
    if (!endDate) return "N/A";
    const today = new Date();
    const end = new Date(endDate);
    const diffTime = end - today;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    if (diffDays < 0) return "Expired";
    if (diffDays === 0) return "Expires today";
    if (diffDays === 1) return "Expires tomorrow";
    return `${diffDays} days remaining`;
  };

  // Add missing utility function
  const dateTimeFormat = ({ dateStr }) => {
    if (!dateStr) return { date: "N/A", time: "" };
    const dateObj = new Date(dateStr);
    const date = dateObj.toLocaleDateString();
    const time = dateObj.toLocaleTimeString();
    return { date, time };
  };

  return (
    <>
      <header className="headerTop">
        <Link to="/" className="logo_box">
          <img alt="Logo" src={logo} className="logo_img" />
        </Link>
        <div className="user_dropdbShow">
          <Button className="ico-search" icon="FaSearch" />
          <button
            className="theme_btn desktop_only"
            title={`Switch to ${theme === "light" ? "dark" : "light"} mode`}
            // onClick={handleTheme}
            aria-label="Toggle theme"
          >
            {theme === "dark" ? (
              <Icon name="FaRegMoon" className="dark-mode" />
            ) : (
              <Icon name="FaSun" className="light-mode" />
            )}
          </button>
          <div className="user_dropdown_wrapper ">
            <button className="btn_user">
              <img src={userImg} alt="user" />
              <span>
                {userName}
                <Icon name="chevronDownIcon" />
              </span>
            </button>

            <div className="menu_dropdbShow">
              <div className="menu-item theme_box mobile_only">
                <span>Theme</span>
                <button
                  className="theme_btn"
                  title={`Switch to ${theme === "light" ? "dark" : "light"} mode`}
                  // onClick={handleTheme}
                  aria-label="Toggle theme"
                >
                  {theme === "dark" ? (
                    <Icon name="FaRegMoon" className="dark-mode" />
                  ) : (
                    <Icon name="FaSun" className="light-mode" />
                  )}
                </button>
              </div>
              <div className="separator mobile_only"></div>

              <div className="menu-item">
                <button
                  className="menu-link"
                  role="menuitem"
                  onClick={() => handleMenuClick("/two-fa")}
                >
                  <Icon name="ShieldPlus" />
                  &nbsp; Two Factor Auth
                </button>
              </div>
              <div className="menu-item">
                <button
                  className="menu-link"
                  role="menuitem"
                  onClick={() => handleMenuClick("/change-password")}
                >
                  <Icon name="RotateCcwKey" />
                  &nbsp; Change Password
                </button>
              </div>
              <div className="separator" role="separator"></div>
              <div className="menu-item">
                <button
                  type="button"
                  className="menu-link"
                  onClick={handleConfirmLogout}
                  role="menuitem"
                >
                  <Icon name="logout" />
                  &nbsp; Logout
                </button>
              </div>
            </div>
          </div>
        </div>
      </header>

      {isShow.isOpen && (
        <CommonModal
          isShow={isShow.isOpen}
          handleShowHide={() =>
            setIsShow((prev) => ({
              ...prev,
              isOpen: false,
              rowData: {},
              name: "",
            }))
          }
          modalTitle={isShow.modalTitle}
        >
          {isShow.modalContent &&
            React.createElement(isShow.modalContent, {
              handleShowHide: () =>
                setIsShow((prev) => ({
                  ...prev,
                  isOpen: false,
                  rowData: {},
                  name: "",
                  modalTitle: "",
                  apiFlag: !prev.apiFlag,
                })),
              rowData: isShow.rowData,
            })}
        </CommonModal>
      )}
    </>
  );
};

export default memo(Topbar);
